import React, { useState } from 'react';
import { FaWhatsapp, FaFacebookF, FaTiktok, FaInstagram, FaSnapchatGhost } from "react-icons/fa";
import { motion } from 'framer-motion';
import { FaPhoneFlip } from "react-icons/fa6";

export default function Contact() {
    const [showContacts, setShowContacts] = useState(false);

    const handleClick = () => setShowContacts(Prev => !Prev);


    return (
        <div
            className='Contact fixed cursor-pointer z-10 w-[60px] h-[60px] bg-[#d48383] text-white rounded-full 
            flex justify-center items-center'>
            <FaPhoneFlip className='text-white text-3xl w-full h-full p-[18px]' onClick={handleClick} />
            <motion.a
                className="Whatsapp w-[30px] h-[30px] absolute bg-[#d48383] text-white rounded-full flex justify-center items-center"
                initial={{ opacity: 0, y: 20, scale: 0 }}
                animate={showContacts ? { opacity: 1, scale: 1, y: 0 } : { opacity: 0, y: 20, scale: 0 }}
                transition={{ duration: 1, type: "spring", delay: 0 }}
                href='https://wa.me/+201021205001?'
                aria-label='Mema WhatsUp'
                target="_blank" rel="external"
            >
                <FaWhatsapp />
            </motion.a>
            <motion.a
                className="Facebook w-[30px] h-[30px] absolute bg-[#d48383] text-white rounded-full flex justify-center items-center"
                initial={{ opacity: 0, y: 20, scale: 0 }}
                animate={showContacts ? { opacity: 1, scale: 1, y: 0 } : { opacity: 0, y: 20, scale: 0 }}
                transition={{ duration: 1, type: "spring", delay: 0.2 }}
                href='https://www.facebook.com/share/5MtSyMqW9kanUmck/?mibextid=LQQJ4d'
                aria-label='Mema Facebook'
                target="_blank" rel="external"
            >
                <FaFacebookF />
            </motion.a>
            <motion.a
                className="Tiktok w-[30px] h-[30px] absolute bg-[#d48383] text-white rounded-full flex justify-center items-center"
                initial={{ opacity: 0, y: 20, scale: 0 }}
                animate={showContacts ? { opacity: 1, scale: 1, y: 0 } : { opacity: 0, y: 20, scale: 0 }}
                transition={{ duration: 1, type: "spring", delay: 0.4 }}
                href="https://www.tiktok.com/@mema.hijab?_t=8rHSPgAMxPc&_r=1"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Mema TikTok"
            >
                <FaTiktok />
            </motion.a>

            <motion.a
                className="Instagram w-[30px] h-[30px] absolute bg-[#d48383] text-white rounded-full flex justify-center items-center"
                initial={{ opacity: 0, x: 20, scale: 0 }}
                animate={showContacts ? { opacity: 1, scale: 1, x: 0 } : { opacity: 0, x: 20, scale: 0 }}
                transition={{ duration: 1, type: "spring", delay: 0.6 }}
                href="https://www.instagram.com/mema.hijab"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Mema Instagram"
            >
                <FaInstagram />
            </motion.a>
        </div>
    );
}
